module.exports = "https://r.nearpod.com/assets/media/image/AvenirLTStd-BookOblique-4c451e42da94f32df6784d07b3a55672.svg";